import {NavHistoryButton} from '../NavHistoryButton';

import type {FC} from 'react';

export interface BackButtonProps {
  onClick: () => void;
  ariaLabel: string;
  disabled?: boolean;
  className?: string;
}

export const BackButton: FC<BackButtonProps> = props => (
  <NavHistoryButton direction="back" {...props} />
);
